import React from 'react'
import { theme } from 'styled-tools'
import styled from 'styled-components'
import FileInput from './FileInput'
import GalleryThumbnail from './GalleryThumbnail'
import ErrorMessage from './ErrorMessage'
import { Row, Column } from '../grid'
import Button from '../button/baseButton'
import UploadImgPlaceholder from '../icons/upload-img-placeholder'
import settings from '../settings'
import features from '../../../../config/magnet/features'

const StyledLabel = styled(Button).attrs({ as: 'label' })`
  position: relative;
  z-index: 1;
  margin: 0;
  text-align: center;
`

const GalleryThumbnailsRow = styled(Row)`
  margin: -5px;
  padding: 0px 0px 15px;
`

const GalleryThumbnailColumn = styled(Column)`
  padding: 5px;
  ${(props) =>
    props.brand === 'magnet' &&
    `
      flex: 0 0 ${features.showQrCodeVideoUpload ? '50%' : '50%'} !important;
      max-width: ${features.showQrCodeVideoUpload ? '50%' : '50%'} !important;
    `}
  ${(props) =>
    props.brand === 'magnet' &&
    props.theme.media.min.sm`
      flex: 0 0 ${features.showQrCodeVideoUpload ? '50%' : '25%'} !important;
      max-width: ${features.showQrCodeVideoUpload ? '50%' : '25%'} !important;
    `}
`

const StyledFileInput = styled(FileInput)`
  display: ${(props) => theme('qrCodeBlock.button.display')(props) || 'block'};
  min-width: ${(props) => theme('qrCodeBlock.button.minWidth')(props)};
`
const ImagePlaceholderContainer = styled.div`
  display: block !important;
  margin-top: 10px;
  margin-bottom: 30px;
`

const SimpleGallery = ({
  uploader,
  files,
  errors,
  multiple,
  debug,
  onClickThumbnail,
  fileInputText,
  fileInputId,
}) => {
  const hasFiles = files.length > 0
  const hasErrors = errors.length > 0

  return (
    <>
      {!hasFiles && settings.brand === 'magnet' && (
        <ImagePlaceholderContainer>
          <UploadImgPlaceholder />
        </ImagePlaceholderContainer>
      )}
      {hasFiles && (
        <GalleryThumbnailsRow debug={debug}>
          {files.map((file) => (
            <GalleryThumbnailColumn
              xs={6}
              sm={4}
              md={3}
              key={file.id}
              brand={settings.brand}
            >
              <GalleryThumbnail
                id={file.id}
                fromServer={file.fromServer}
                uploader={uploader}
                status={file.status}
                metadata={file.metadata}
                onClick={onClickThumbnail}
                deleteButton={file.metadata && !!file.metadata.blobName}
              />
            </GalleryThumbnailColumn>
          ))}
        </GalleryThumbnailsRow>
      )}
      <StyledFileInput id={fileInputId} uploader={uploader} multiple={multiple}>
        <StyledLabel htmlFor={fileInputId} size="small" block>
          {fileInputText}
        </StyledLabel>
      </StyledFileInput>
      {hasErrors && (
        <Row>
          <Column>
            {errors.map((error) => (
              <ErrorMessage {...error} key={error.id} uploader={uploader} />
            ))}
          </Column>
        </Row>
      )}
    </>
  )
}

SimpleGallery.defaultProps = {
  multiple: true,
  files: [],
  errors: [],
  debug: false,
  onClickThumbnail: null,
  fileInputText: null,
  fileInputId: null,
}

export default SimpleGallery
